<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t2">Readers love</span></p>
<p class="p0"><span class="t3">R</span><span class="t4">USSELL</span> <span class="t3">J. S</span><span class="t4">ANDERS</span></p>
<p class="p2"><span class="t5">The Book of Ethan</span></p>
<p class="p3">“<span class="t7">The Book of Ethan</span> was a very enjoyable read that doesn’t easily fit into any specific subgenre... The author definitely has talent.”</p>
<p class="p4">—Prism Book Alliance</p>
<p class="p3">“I really enjoyed the diversity in this book... I will probably be on the lookout for more from this author.”</p>
<p class="p5">—Scattered Thoughts and Rogue Words</p>
<p class="p2"><span class="t5">Special Effect</span></p>
<p class="p3">“<span class="t7">Special Effect</span> is a quirky novel: part murder mystery, part coming-of-age tale, and part romance.”</p>
<p class="p5">—Rainbow Book Reviews</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?1c18e35a